import { withI18n } from 'react-i18next';
import TrackingRow from './TrackingRow';

export const pureComponent = TrackingRow;
export default withI18n()(TrackingRow);
